import { O } from '@mobily/ts-belt'

export const byDefault = <T>(value: T | undefined | null, defaultValue: T) =>
  O.getWithDefault(O.fromNullable(value), defaultValue)
